import { Candidate } from '../types/Candidate';
import avatar1 from './img/avatar1.png';
import avatar2 from './img/avatar2.png';
import avatar3 from './img/avatar3.png';
import avatar4 from './img/avatar4.png';
import avatar5 from './img/avatar5.png';
import avatar6 from './img/avatar6.png';


export const candidatesData: Candidate[] = [
  { name: 'Camila Perez', date: '18 ago', stars: 5, image: avatar1, discarded: false },
   { name: 'Alejandro Alvaro', date: '18 ago', stars: 5, image: avatar2, discarded: false },
  { name: 'Maria Perez', date: '24 ene', stars: 4, image: avatar3, discarded: false },
  { name: 'Diana mora', date: '8 ago', stars: 2, image: avatar4, discarded: false },
 { name: 'Agustin Perez', date: '20 ene', stars: 4, image: avatar5, discarded: false },
  { name: 'Alejandro Alvaro', date: '18 ago', stars: 5, image: avatar6, discarded: false },
  { name: 'Camila Perez', date: '18 ago', stars: 5, image: avatar1, discarded: false },
   { name: 'Alejandro Alvaro', date: '18 ago', stars: 5, image: avatar2, discarded: false },


];

export const psychometricTestsData: Candidate[] = [
  { name: 'Camila Perez', date: '18 ago', stars: 5, image: avatar1, discarded: false },
  { name: 'Alejandro Alvaro', date: '18 ago', stars: 5, image: avatar2, discarded: false },
 { name: 'Maria Perez', date: '24 ene', stars: 4, image: avatar3, discarded: false },
 { name: 'Diana mora', date: '8 ago', stars: 2, image: avatar4, discarded: false },
{ name: 'Agustin Perez', date: '20 ene', stars: 4, image: avatar5, discarded: false },
 { name: 'Alejandro Alvaro', date: '18 ago', stars: 5, image: avatar6, discarded: false },

];

export const interviewData: Candidate[] = [
  { name: 'Camila Perez', date: '18 ago', stars: 5, image: avatar1, discarded: false },
  { name: 'Alejandro Alvaro', date: '18 ago', stars: 5, image: avatar2, discarded: false },
 { name: 'Maria Perez', date: '24 ene', stars: 4, image: avatar3, discarded: false },
 { name: 'Diana mora', date: '8 ago', stars: 2, image: avatar4, discarded: false },

];